import { h, Fragment } from 'preact'
import { Button } from '../../components/button'
import * as style from './style.css'

interface Props {
    isOpen: boolean
    closeModal: () => void
    handleProceed: () => void
}

const PatientHasAppointmentInLast7DaysModal: preact.FunctionalComponent<Props> = (props) => {
    const { isOpen, closeModal, handleProceed } = props

    return (
        <div
            class={
                isOpen
                    ? style.patientHasAppointmentInLast7DaysModalWrapperBackdrop
                    : style.patientHasAppointmentInLast7DaysModalWrapper
            }
        >
            <Fragment>
                {isOpen && (
                    <div class={style.patientHasAppointmentInLast7DaysModalOverlay}>
                        <div>
                            <div>
                                <i className={style.patientHasAppointmentInLast7DaysModalIcon}>event_available</i>
                            </div>
                            <div className={style.patientHasAppointmentInLast7DaysModalText}>
                                It looks like you scheduled an appointment with us in the past 7 days. Are you sure you
                                want to proceed?
                            </div>
                            <div className={style.patientHasAppointmentInLast7DaysModalActionButtons}>
                                <span>
                                    <Button primary={false} onClick={closeModal}>
                                        CANCEL
                                    </Button>
                                </span>
                                <span className={style.patientHasAppointmentInLast7DaysModalProceedButton}>
                                    <Button primary={true} onClick={handleProceed}>
                                        PROCEED ›
                                    </Button>
                                </span>
                            </div>
                        </div>
                    </div>
                )}
            </Fragment>
        </div>
    )
}

export default PatientHasAppointmentInLast7DaysModal
